import {
  FetchTransport,
  initializeFaro,
  getWebInstrumentations,
  ReactIntegration,
  ReactRouterVersion,
} from '@grafana/faro-react';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import { Route } from 'react-router-dom';

/**
 * reporting of errors and sessions that get sent to grafana.
 * @param history
 * @returns {Faro}
 */
const initFaro = (history) => {
  if (window.baseAppConfig.faroTransportPath && window.baseAppConfig.faroApiKey) {
    const transportURL = new URL(window.baseAppConfig.faroTransportPath, window.location.origin);
    return initializeFaro({
      instrumentations: [
        ...getWebInstrumentations({ captureConsole: false }),
        // Tracing Instrumentation is needed if you want to use the React Profiler
        new TracingInstrumentation(),
        new ReactIntegration({
          router: {
            version: ReactRouterVersion.V5, // or ReactRouterVersion.V4,
            dependencies: {
              history, // the history object used by react-router
              Route, // Route component imported from react-router package
            },
          },
        }),
      ],
      transports: [
        new FetchTransport({
          url: transportURL.href,
          apiKey: window.baseAppConfig.faroApiKey,
        }),
      ],
      app: {
        name: window.baseAppConfig.podName,
        version: window.baseAppConfig.version,
      },
    });
  }
};
export default initFaro;
